import { configureStore } from '@reduxjs/toolkit';
import homeReducer from '../features/home/homeSlice';
import authReducer from '../features/auth/authSlice';
import wholesalerReducer from '../features/wholesaler/wholesalerSlice';
import orderReducer from '../features/order/orderSlice';
import connectionReducer from '../features/connections/connectionSlice';
import retailerReducer from '../features/retailer/retailerSlice';
import productsReducer from '../features/products/productsSlice'

export const store = configureStore({
  reducer: {
    home: homeReducer,
    auth: authReducer,
    wholesaler: wholesalerReducer,
    orders: orderReducer,
    connections: connectionReducer,
    retailer: retailerReducer,
    products: productsReducer
  }
});

export default store;
